export default __webpack_public_path__ + "static/media/Prabhupada.c3c863de.png";